export default __webpack_public_path__ + "static/media/img20.7770aa7e.png";